import TRASH from "../../assets/image/TRASH.svg";
import isSuccessImg from "../../assets/image/isSuccess.svg";

const DeleteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  message = "Are you sure you want to remove this item?",
  confirmText = "Yes",
  cancelText = "No",
  isDelete = true,
  isSuccess = false,
  isRequest = false,
  loading = false,
}) => {
  if (!open) return null;

  return (
    <div className="modal d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        {isDelete && (
          <div className="modal-content rounded-4 p-3 delete_pop_up">
            <div className="text-center">
              <img
                src={TRASH}
                alt="icon"
                width="40"
                height="40"
                className="mb-3"
              />
              <h5 className="mb-3 fw-semibold">{message}</h5>
              <div className="d-flex justify-content-center gap-3">
                <button
                  onClick={onConfirm}
                  className="btn btn-dark px-4 py-2 rounded-3"
                >
                  {confirmText}
                </button>
                <button
                  onClick={onClose}
                  className="btn btn-outline-dark px-4 py-2 rounded-3"
                >
                  {cancelText}
                </button>
              </div>
            </div>
          </div>
        )}
        {isRequest && (
          <div className="modal-content rounded-4 p-3 delete_pop_up">
            <div className="text-center">
              <img
                src={isSuccessImg}
                alt="icon"
                width="40"
                height="40"
                className="mb-3"
              />
              <h5 className="mb-3 fw-semibold">{message}</h5>
              <div className="d-flex justify-content-center gap-3">
                <button
                  disabled={loading}
                  onClick={onConfirm}
                  className="btn btn-dark px-4 py-2 rounded-3"
                >
                  {confirmText}
                </button>
                <button
                  onClick={onClose}
                  className="btn btn-outline-dark px-4 py-2 rounded-3"
                >
                  {cancelText}
                </button>
              </div>
            </div>
          </div>
        )}
        {isSuccess && (
          <div className="modal-content rounded-4 p-3 delete_pop_up">
            <div className="text-center">
              <img
                src={isSuccessImg}
                alt="icon"
                width="40"
                height="40"
                className="mb-3"
              />
              <h5 className="mb-3 fw-semibold" style={{ width: "96%" }}>
                {message}
              </h5>
              <div className="d-flex justify-content-center gap-3">
                <button
                  onClick={onConfirm}
                  className="btn btn-dark px-4 py-2 rounded-3"
                  style={{ width: "50%" }}
                >
                  {confirmText}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
